import React from "react";
import { ApiHelper, DateHelper, EnvironmentHelper, ScreenInterface, UserHelper } from "../../helpers";
import { Row, Col, FormControl, Button } from "react-bootstrap"
import { DisplayBox, Loading } from "../../components"
import { ErrorLogs } from "./ErrorLogs";

interface Props {
  screen: ScreenInterface
}

export const ScreenHealth: React.FC<Props> = props => {

  const [showActivity, setShowActivity] = React.useState(false);
  const [commandName, setCommandName] = React.useState("updateInstructions");

  const getActivity = () => {
    if (showActivity) return <ErrorLogs screenId={props.screen.id} />
    else return <a href="about:blank" onClick={(e) => { e.preventDefault(); setShowActivity(true) }}>Show logs</a>
  }

  const handleSendCommand = () => {
    const command = { playerId: props.screen.admId, actionName: commandName }
    ApiHelper.post("/adm/sendCommands", [command]);
  }

  const getAdminOptions = () => {
    if (UserHelper.checkAccess("admin")) {
      return (<>
        <br />
        {getCommands()}
        <br />
        {getActivity()}
      </>);
    } else return <></>
  }

  const handleChange = (e: any) => {
    setCommandName(e.currentTarget.value);
  }

  const getCommands = () => {
    return (<Row>
      <Col>
        <FormControl as="select" onChange={handleChange} value={commandName}>
          <option value="updateInstructions">Update Instructions</option>
          <option value="clearCache">Clear Cache</option>
          <option value="health">Update Health</option>
          <option value="restart">Restart</option>
        </FormControl>
      </Col>
      <Col className="d-grid">
        <Button type="submit" variant="primary" className="w-100" onClick={handleSendCommand}>
          Send Command
        </Button>
      </Col>
    </Row>);
  }

  React.useEffect(() => { setShowActivity(false) }, [props.screen]);

  if (!UserHelper.checkAccess("admin")) return <></>
  if (!props.screen) return <Loading />
  else {
    var imgUrl = EnvironmentHelper.ContentRoot + "/screenshots/" + props.screen.id + ".jpg";
    if (props.screen.healthReportTime) {
      const t = new Date(Date.parse(props.screen.healthReportTime.toString()));
      imgUrl += "?ts=" + t.getTime().toString();
    }

    const cacheSize = Math.round(props.screen.cacheSize / 1024 / 1024 * 100) / 100;

    return (
      <DisplayBox headerIcon="fas fa-tv" headerText="Screen Health">
        <img src={imgUrl} alt="Screenshot" />
        <Row>
          <Col><b>App Version:</b> {props.screen.appVersion}</Col>
          <Col><b>Health Report:</b> {(props.screen.healthReportTime) ? DateHelper.prettyDateTime(DateHelper.convertToDate(props.screen.healthReportTime)) : ""}</Col>
        </Row>
        <Row>
          <Col><b>WiFi Network:</b> {props.screen.wifiNetwork}</Col>
          <Col><b>Reported Time:</b> {(props.screen.reportedTime) ? DateHelper.prettyDateTime(DateHelper.convertToDate(props.screen.reportedTime)) : ""}</Col>
        </Row>
        <Row>
          <Col><b>WiFi Strength:</b> {props.screen.wifiStrength} db</Col>
          <Col><b>Cache Size:</b> {cacheSize} MB</Col>
        </Row>
        {getAdminOptions()}
      </DisplayBox>
    );
  }

}